<template>
  <div>
    <div v-if="getInfoItems.length > 0">
      <div v-for="(product, index) in getInfoItems" :key="index">
        <h6
          v-if="item.type === 'level_1' || product.type === 'product'"
        >{{ product.name }}</h6>
        <h6 v-else-if="item.type === 'level_3'">Übersicht Ihrer individuell zusammengestellten Präsent-Komposition</h6>
        <ul class="o-nutrition-list">
          <li
            class="o-nutrition-list__item"
            v-for="attribute in product.attributes.filter(it => !(it.name === 'DimX' || it.name === 'DimY' || it.name === 'Dim_X' || it.name === 'Dim_Y' || it.name === 'Rotierbar' || it.name === 'MhDKlasse' || (it.name === 'Geschmack' && it.value.join(', ') === '0') || (it.name === 'Geschmack' && it.value.join(', ') === '')))"
            :key="attribute.name"
          >
            <div class="o-nutrition-list__property">{{ attribute.name }}</div>
            <div class="o-nutrition-list__value">{{ attribute.value.join(', ') }}</div>
          </li>

          <li
            class="o-nutrition-list__item"
            v-if="
              product.food_info['_unit_regular_price_per_unit'] !== null &&
                product.food_info['_unit_regular_price_per_unit'] !== undefined &&
                product.food_info['_unit_regular_price_per_unit'] !== '' &&
                product.food_info['_auto_ppu_complete_product_quantity'] !==
                  null &&
                product.food_info['_auto_ppu_complete_product_quantity'] !== ''
            "
          >
            <div class="o-nutrition-list__property">Menge</div>
            <div class="o-nutrition-list__value">
              {{
              product.food_info[
              '_auto_ppu_complete_product_quantity'
              ].replace('.', ',')
              }}
              {{ getUnit(product.food_info['_unit_regular_price_per_unit']) }}
            </div>
          </li>
          <li
            class="o-nutrition-list__item"
            v-if="
            '_fic_ingredients' in product.food_info &&
              product.food_info['_fic_ingredients'] !== null &&
              product.food_info['_fic_ingredients'] !== undefined &&
                product.food_info['_fic_ingredients'] !== ''
            "
          >
            <div class="o-nutrition-list__property">Zutaten</div>
            <div
              class="o-nutrition-list__value"
              v-html="
                product.food_info['_fic_ingredients']
                  .replace(/\[h\]/g, '<strong>')
                  .replace(/\[\/h\]/g, '</strong>')
              "
            ></div>
          </li>
          <li
            class="o-nutrition-list__item"
            v-if="
            '_nutritional_values_remark' in product.food_info &&
              product.food_info['_nutritional_values_remark'] !== null &&
              product.food_info['_nutritional_values_remark'] !== undefined &&
                product.food_info['_nutritional_values_remark'] !== ''
            "
          >
            <div class="o-nutrition-list__property">Bemerkung</div>
            <div
              class="o-nutrition-list__value"
            >{{ product.food_info['_nutritional_values_remark'] }}</div>
          </li>
          <li
            class="o-nutrition-list__item"
            v-if="
            '_nutritional_values_1000-energy' in product.food_info &&
              product.food_info['_nutritional_values_1000-energy'] !== null &&
              product.food_info['_nutritional_values_1000-energy'] !== undefined &&
                product.food_info['_nutritional_values_1000-energy'] !== ''
            "
          >
            <div class="o-nutrition-list__property">Brennwert</div>
            <div
              class="o-nutrition-list__value"
            >{{ product.food_info['_nutritional_values_1000-energy'] }}</div>
          </li>
          <li
            class="o-nutrition-list__item"
            v-if="
            '_nutritional_values_2000-fat' in product.food_info &&
              product.food_info['_nutritional_values_2000-fat'] !== null &&
              product.food_info['_nutritional_values_2000-fat'] !== undefined &&
                product.food_info['_nutritional_values_2000-fat'] !== ''
            "
          >
            <div class="o-nutrition-list__property">Fett</div>
            <div
              class="o-nutrition-list__value"
            >{{ product.food_info['_nutritional_values_2000-fat'] }}</div>
          </li>
          <li
            class="o-nutrition-list__item"
            v-if="
            '_nutritional_values_2100-fat-saturates' in product.food_info &&
              product.food_info['_nutritional_values_2100-fat-saturates'] !==
                null &&
                product.food_info['_nutritional_values_2100-fat-saturates'] !==
                  ''
            "
          >
            <div class="o-nutrition-list__property">- davon Gesättigte Fettsäuren</div>
            <div
              class="o-nutrition-list__value"
            >{{ product.food_info['_nutritional_values_2100-fat-saturates'] }}</div>
          </li>
          <li
            class="o-nutrition-list__item"
            v-if="
            '_nutritional_values_2200-fat-mono-unsaturates' in product.food_info &&
              product.food_info[
                '_nutritional_values_2200-fat-mono-unsaturates'
              ] !== null &&
              product.food_info[
                '_nutritional_values_2200-fat-mono-unsaturates'
              ] !== undefined &&
                product.food_info[
                  '_nutritional_values_2200-fat-mono-unsaturates'
                ] !== ''
            "
          >
            <div class="o-nutrition-list__property">- davon Einfach ungesättigte Fettsäuren</div>
            <div class="o-nutrition-list__value">
              {{
              product.food_info[
              '_nutritional_values_2200-fat-mono-unsaturates'
              ]
              }}
            </div>
          </li>
          <li
            class="o-nutrition-list__item"
            v-if="
            '_nutritional_values_2300-fat-polyunsaturates' in product.food_info &&
              product.food_info[
                '_nutritional_values_2300-fat-polyunsaturates'
              ] !== null &&
              product.food_info[
                '_nutritional_values_2300-fat-polyunsaturates'
              ] !== undefined &&
                product.food_info[
                  '_nutritional_values_2300-fat-polyunsaturates'
                ] !== ''
            "
          >
            <div class="o-nutrition-list__property">- davon Mehrfach ungesättigte Fettsäuren</div>
            <div class="o-nutrition-list__value">
              {{
              product.food_info[
              '_nutritional_values_2300-fat-polyunsaturates'
              ]
              }}
            </div>
          </li>
          <li
            class="o-nutrition-list__item"
            v-if="
            '_nutritional_values_3000-carbohydrate' in product.food_info &&
              product.food_info['_nutritional_values_3000-carbohydrate'] !==
                null &&
                product.food_info['_nutritional_values_3000-carbohydrate'] !==
                  ''
            "
          >
            <div class="o-nutrition-list__property">Kohlenhydrate</div>
            <div
              class="o-nutrition-list__value"
            >{{ product.food_info['_nutritional_values_3000-carbohydrate'] }}</div>
          </li>
          <li
            class="o-nutrition-list__item"
            v-if="
            '_nutritional_values_3100-carbohydrate-sugars' in product.food_info &&
              product.food_info[
                '_nutritional_values_3100-carbohydrate-sugars'
              ] !== null &&
              product.food_info[
                '_nutritional_values_3100-carbohydrate-sugars'
              ] !== undefined &&
                product.food_info[
                  '_nutritional_values_3100-carbohydrate-sugars'
                ] !== ''
            "
          >
            <div class="o-nutrition-list__property">- davon Zucker</div>
            <div class="o-nutrition-list__value">
              {{
              product.food_info[
              '_nutritional_values_3100-carbohydrate-sugars'
              ]
              }}
            </div>
          </li>
          <li
            class="o-nutrition-list__item"
            v-if="
            '_nutritional_values_3200-carbohydrate-polyols' in product.food_info &&
              product.food_info[
                '_nutritional_values_3200-carbohydrate-polyols'
              ] !== null &&
              product.food_info[
                '_nutritional_values_3200-carbohydrate-polyols'
              ] !== undefined &&
                product.food_info[
                  '_nutritional_values_3200-carbohydrate-polyols'
                ] !== ''
            "
          >
            <div class="o-nutrition-list__property">- davon Mehrwertige Alkohole</div>
            <div class="o-nutrition-list__value">
              {{
              product.food_info[
              '_nutritional_values_3200-carbohydrate-polyols'
              ]
              }}
            </div>
          </li>
          <li
            class="o-nutrition-list__item"
            v-if="
            '_nutritional_values_3300-carbohydrate-starch' in product.food_info &&
              product.food_info[
                '_nutritional_values_3300-carbohydrate-starch'
              ] !== null &&
              product.food_info[
                '_nutritional_values_3300-carbohydrate-starch'
              ] !== undefined &&
                product.food_info[
                  '_nutritional_values_3300-carbohydrate-starch'
                ] !== ''
            "
          >
            <div class="o-nutrition-list__property">- davon Stärke</div>
            <div class="o-nutrition-list__value">
              {{
              product.food_info[
              '_nutritional_values_3300-carbohydrate-starch'
              ]
              }}
            </div>
          </li>
          <li
            class="o-nutrition-list__item"
            v-if="
            '_nutritional_values_4000-fibre' in product.food_info &&
              product.food_info['_nutritional_values_4000-fibre'] !== null &&
              product.food_info['_nutritional_values_4000-fibre'] !== undefined &&
                product.food_info['_nutritional_values_4000-fibre'] !== ''
            "
          >
            <div class="o-nutrition-list__property">Ballaststoffe</div>
            <div
              class="o-nutrition-list__value"
            >{{ product.food_info['_nutritional_values_4000-fibre'] }}</div>
          </li>
          <li
            class="o-nutrition-list__item"
            v-if="
            '_nutritional_values_5000-protein' in product.food_info &&
              product.food_info['_nutritional_values_5000-protein'] !== null &&
              product.food_info['_nutritional_values_5000-protein'] !== undefined &&
                product.food_info['_nutritional_values_5000-protein'] !== ''
            "
          >
            <div class="o-nutrition-list__property">Eiweiß</div>
            <div
              class="o-nutrition-list__value"
            >{{ product.food_info['_nutritional_values_5000-protein'] }}</div>
          </li>
          <li
            class="o-nutrition-list__item"
            v-if="
            '_nutritional_values_6000-salt' in product.food_info &&
              product.food_info['_nutritional_values_6000-salt'] !== null &&
              product.food_info['_nutritional_values_6000-salt'] !== undefined &&
                product.food_info['_nutritional_values_6000-salt'] !== ''
            "
          >
            <div class="o-nutrition-list__property">Salz</div>
            <div
              class="o-nutrition-list__value"
            >{{ product.food_info['_nutritional_values_6000-salt'] }}</div>
          </li>
          <li
            class="o-nutrition-list__item"
            v-if="
            '_nutritional_values_7000-vitamins-and-minerals' in product.food_info &&
              product.food_info[
                '_nutritional_values_7000-vitamins-and-minerals'
              ] !== null &&
              product.food_info[
                '_nutritional_values_7000-vitamins-and-minerals'
              ] !== undefined &&
                product.food_info[
                  '_nutritional_values_7000-vitamins-and-minerals'
                ] !== ''
            "
          >
            <div class="o-nutrition-list__property">Vitamine und Mineralien</div>
            <div class="o-nutrition-list__value">
              {{
              product.food_info[
              '_nutritional_values_7000-vitamins-and-minerals'
              ]
              }}
            </div>
          </li>
          <li
            class="o-nutrition-list__item"
            v-if="
            '_allergens_info' in product.food_info &&
              product.food_info['_allergens_info'] !== null &&
              product.food_info['_allergens_info'] !== undefined &&
                product.food_info['_allergens_info'] !== ''
            "
          >
            <div class="o-nutrition-list__property">Allergene Information</div>
            <div class="o-nutrition-list__value" v-html="product.food_info['_allergens_info']"></div>
          </li>
          <li
            class="o-nutrition-list__item"
            v-if="
            '_alcohol_value' in product.food_info &&
              product.food_info['_alcohol_value'] !== null &&
              product.food_info['_alcohol_value'] !== undefined &&
                product.food_info['_alcohol_value'] !== '' &&
                product.food_info['_alcohol_value'] !== '% vol'
            "
          >
            <div class="o-nutrition-list__property">Alkohol Wert</div>
            <div class="o-nutrition-list__value">
              {{ product.food_info['_alcohol_value'] }}
              {{ product.food_info['_alcohol_unit'] }}
            </div>
          </li>
          <li class="o-nutrition-list__item" v-if="product.age_restriction !== ''">
            <div class="o-nutrition-list__property">Erforderliches Alter</div>
            <div class="o-nutrition-list__value">{{ product.age_restriction }}</div>
          </li>
          <li class="o-nutrition-list__item" v-if="product.brands.length > 0">
            <div class="o-nutrition-list__property">Hersteller</div>
            <div class="o-nutrition-list__value">
              {{ product.brands[0].name }}
              <br />
              <div v-html="product.brands[0].description"></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- /legal info -->
  </div>
</template>

<script>
export default {
  name: 'LegalInfo',
  props: ['item'],
  methods: {
    checkItemProperties: function(item) {
      if (item.brands.length > 0) {
        return true;
      }
      if (
        item.attributes.filter(
          it =>
            !(
              it.name === 'DimX' ||
              it.name === 'DimY' ||
              it.name === 'Dim_X' ||
              it.name === 'Dim_Y' ||
              it.name === 'Rotierbar' ||
              it.name === 'MhDKlasse' ||
              (it.name === 'Geschmack' && it.value.join(', ') === '0')
            )
        ).length > 0
      ) {
        return true;
      }
      if (item.age_restriction !== '') {
        return true;
      }
      for (var key in item.food_info) {
        if (item.food_info[key] !== null && item.food_info[key] !== '') {
          return true;
        }
      }

      return false;
    },
    getUnit: function(unit) {
      if (unit === 'L') {
        return 'Liter';
      }

      return unit;
    }
  },
  computed: {
    getInfoItems: function() {
      var products = [];
      if (
        this.item.type === 'level_1' ||
        this.item.type === 'level_3'
      ) {
        this.item.products.forEach(product => {
          if ('products' in product) {
            product.products.forEach(p => {
              if (p.type === 'product' && this.checkItemProperties(p)) {
                products.push(p);
              }
            });
          } else if (
            product.type === 'product' &&
            this.checkItemProperties(product)
          ) {
            products.push(product);
          }
        });
      } else if (
        this.item.type === 'product' &&
        this.checkItemProperties(this.item)
      ) {
        products.push(this.item);
      }

      return products;
    }
  }
};
</script>

<style>
.o-nutrition-list__value strong {
  text-transform: uppercase;
}
</style>
